import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map, Observable } from 'rxjs';

export interface ExemptedEmb {
  active: boolean;
  added_by: string;
  added_on: string;
  corporate_name: string;
  email: string;
  used_on: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExemptedEmbService {

  constructor(private firestore: AngularFirestore) {}

  // Fetch an exempted EMB record by email.
  getExemptedEmbByEmail(email: string): Observable<ExemptedEmb | null> {
    return this.firestore
      .collection<ExemptedEmb>('exempted_embs', ref => ref.where('email', '==', email))
      .valueChanges()
      .pipe(map(arr => arr.length ? arr[0] : null));
  }
}
